import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6 text-center">Terms and Conditions</h1>

      {/* Access */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Access</h2>
        <p>
          You are provided with access to this website in accordance with these conditions and any
          transactions made by you must be placed strictly in accordance with these conditions.
        </p>
      </section>

      {/* Registration */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Registration</h2>
        <p>You warrant that:</p>
        <ul className="list-disc list-inside ml-4">
          <li>
            The personal information which you are required to provide when you register as a
            customer is true, accurate, current and complete in all respects.
          </li>
          <li>
            You agree not to impersonate any other person or entity or to use a false name or a name
            that you are not authorized to use.
          </li>
        </ul>
      </section>

      {/* Indemnity */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Indemnity</h2>
        <p>
          You agree to indemnify, defend and hold us, and our officers, directors, employees,
          agents, and suppliers harmless from all claims, liability, damages, losses, costs, and
          expenses (including legal fees) arising from any breach of these conditions by you or
          other liabilities arising from your use of this website.
        </p>
      </section>

      {/* Our Rights */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Our Rights</h2>
        <p>We reserve the right to:</p>
        <ul className="list-disc list-inside ml-4">
          <li>
            Modify or withdraw this website (or any part thereof) without notice to you, and confirm
            that we shall not be liable to you or any third party for such modification or
            withdrawal.
          </li>
          <li>
            Change the conditions from time to time. Continued use of the website shall be deemed as
            acceptance of such changes.
          </li>
        </ul>
      </section>

      {/* Third Party Links */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Third Party Links</h2>
        <p>
          We may provide links to other websites or resources. You acknowledge that we are not
          responsible for the availability, content, or privacy practices of such external sites or
          resources.
        </p>
      </section>

      {/* durapot Online Username and Membership */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">durapot Online Username and Membership</h2>
        <p>
          Creating a "durapot username" is compulsory for placing an order. When you sell or exchange an
          item online or in-store, you confirm that you are legally entitled to sell the goods to
          durapot.
        </p>
        <p>
          We reserve the right to deactivate your online account or durapot membership without
          explanation.
        </p>
      </section>

      {/* Images */}
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Images</h2>
        <p>Images are for illustration only. Actual item design may vary slightly.</p>
      </section>

   

      {/* Age Restriction */}
    

      {/* Last Updated */}
      <div className="mt-8 text-center text-gray-500">
        <p>Last Updated: April 2025</p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
